import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
    // console.log("probando turbo-modal controller");
  }

  hideModal() {
    // dispatch a global event so other controllers (e.g., roles-persist) can reset state on modal close
    try {
      document.dispatchEvent(new CustomEvent('roles-persist:reset'))
    } catch (err) {
      // ignore if dispatch fails
    }

    if (this.element.parentElement.getAttribute("src")) {
      this.element.parentElement.removeAttribute("src"); // it might be nice to also remove the modal SRC
    }
    this.element.remove();
  }

  submitEnd(e) {
    if (e.detail.success) {
      const notClose = document.querySelector(".notClose");
      if (notClose) {
        e.preventDefault();
      } else {
        this.hideModal();
      }
    }
  }
  closeWithKeyboard(e) {
    if (e.code == "Escape") {
      this.hideModal();
    }
  }

  closeBackground(e) {
    // Verificar si el clic se originó fuera del sidebar
    if (e.target.classList.contains("modal-backdrop")) {
      this.hideModal();
    } else {
    }
  }
}
